const values = {
  0: "pb-0",
  0.5: "pb-0.5",
  1: "pb-1",
  1.5: "pb-1.5",
  2: "pb-2",
  2.5: "pb-2.5",
  3: "pb-3",
  3.5: "pb-3.5",
  4: "pb-4",
  5: "pb-5",
  6: "pb-6",
  7: "pb-7",
  8: "pb-8",
  9: "pb-9",
  10: "pb-10",
  12: "pb-12",
  14: "pb-14",
  16: "pb-16",
  20: "pb-20",
  24: "pb-24",
  28: "pb-28",
  32: "pb-32",
  36: "pb-36",
  40: "pb-40",
  44: "pb-44",
  48: "pb-48",
  52: "pb-52",
  56: "pb-56",
  60: "pb-60",
  64: "pb-64",
  72: "pb-72",
  80: "pb-80",
  96: "pb-96",
};

export default function getPaddingBottom(value) {
  return values[value];
}
